import { decryptJson, decryptText, encryptJson } from "../utils/crypt";

// Función para detectar si estamos en producción
const isProduction = () => {
  return import.meta.env.PROD || import.meta.env.MODE === 'production';
};

// Función para determinar si debe usar encriptación
export const shouldUseEncryption = () => {
  return isProduction() && import.meta.env.VITE_ENABLE_ENCRYPTION === 'true';
};

const requestOptions = (method, body, token = '') => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (token) {
    headers['Authorization'] = 'Bearer ' + token;
  }
  const options = {
    method,
    headers,
  }
  if (method !== 'GET') {
    if (shouldUseEncryption()) {
      const bodyEncrypted = {
        secret_key: encryptJson(body)
      };
      options.body = JSON.stringify(bodyEncrypted);
    } else {
      options.body = JSON.stringify(body);
    }
  }
  return options;
};

const requestOptionsFile =  (method, body, token = '') => {
  const headers = {};
  if (token) {
    headers['Authorization'] = 'Bearer ' + token;
  }
  return {
    method,
    headers,
    body
  }
};


const handleResponse = async (response) => {
  if (!response.ok) {
    if (shouldUseEncryption()) {
      const data = await response.json();
      const textDecrypted = decryptText(data?.data);
      return Promise.reject({
        status: response.status,
        message: textDecrypted
      });
    }
    return Promise.reject(response.status);
  }
  if (response.status) {
    if (response.status === 204 || response.status === 302) {
      return Promise.resolve({
        status: response.status,
        data: {},
      });
    }

    const data = await response.json();
    if (shouldUseEncryption()) {
      const dataDecrypted = data?.data ? decryptJson(data.data) : decryptJson(data);
      return Promise.resolve({
        status: response.status,
        data: dataDecrypted,
      });
    }
    return Promise.resolve({
      status: response.status,
      data,
    });
  }
};

export {
  requestOptions,
  requestOptionsFile,
  handleResponse
}
